import { useMemo } from 'react';

import { useDataFlowResponseOptions } from '../use-data-flow-response-options/use-data-flow-response-options';
import { useDirectionOptions } from '../use-direction-options/use-direction-options';
import { useLocationOptions } from '../use-location-options/use-location-options';
import { useSensorOptions } from '../use-sensor-options/use-sensor-options';

export const initialProtocols = [
  'http',
  'https',
  'http-proxy',
  'tcp',
  'udp',
  'snmp',
  'smtp',
  'ssh',
  'domain',
  'ftp',
  'tftp',
  'imap',
  'imaps',
  'rtmp',
  'sip',
  'ntp',
  'isakmp',
  'openvpn',
  'pop3',
  'pop3s',
  'ipsec',
];

export const useFlowDataFilterOptions = () => {
  const device = useDataFlowResponseOptions('device', undefined);
  const protocol = useDataFlowResponseOptions(
    'protocol',
    initialProtocols.map((protocol) => ({ value: protocol, label: protocol })),
  );
  const location = useLocationOptions();
  const site = useDataFlowResponseOptions('site');
  const sensor = useSensorOptions();
  const direction = useDirectionOptions();

  return useMemo(
    () => ({
      device,
      protocol,
      location,
      site,
      sensor,
      direction,
    }),
    [device, direction, location, protocol, sensor, site],
  );
};
